<template>
  <section v-if="freeShipping && freeShipping.length" class="free-shipping custom-container mb-5 position-relative d-flex">
    <div class="title d-flex flex-column flex-wrap gap-12 align-items-center justify-content-center overflow-hidden">
      <h3 class="text-color-444 fontsize-heavy text-nowrap m-0">ارسال رایگان</h3>
      <div class="icon py-2 py-lg-5">
        <freeShippingIcon class="freeShipping-icon  order-sm-2" />
      </div>
      <!-- <router-link
        class="text-color-white fontsize-mini order-2 order-sm-3 bg-color-theme2 text-center text-nowrap py-2 px-4"
        :to="{
          name: 'product.category',
          params: { category: item.id, slug: slugGenerator(item.slug) },
        }"
      >
        مشاهده همه
      </router-link> -->
     
    </div>
    <div  class="mt-1 productContainer position-relative">
      <div
        class="swiper-container w-100 py-3 px-lg-4"
     >
        <div class="swiper-wrapper">
          <div class="swiper-slide"   v-for="(product, index) in freeShipping"  :key="index + 'index'">
            <Product
            class=""
            :product="product"
          />
          </div>
        
        </div>
      
      </div>
    </div>
  </section>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
import Swiper from "swiper/swiper-bundle.min";
import freeShippingIcon from "@/parts/Front/components/Icon/freeShipping.vue";
let breakpoints = {
  300: {
    slidesPerView: 1.5,
    spaceBetween: 15,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  1200: {
    slidesPerView: 3.5,
    spaceBetween: 20,
  },
    1500: {
    slidesPerView: 4,
    spaceBetween: 20,
  },
};
export default {
  name:"freeShippingProduct",
   props: {
    item: Object,
  },
  components: {
    Product,
    freeShippingIcon,
  },
  
  mounted() {
    this.initSlider(false);
  },
   watch: {
    freeShipping() {
      
      this.initSlider(true);
    },
   },
  methods: {
    slugGenerator(item) {
      if (item.slug) return item.slug;
      return item.title?.replaceAll(" ", "-");
    },
    initSlider(kill = false) {
      this.initSwiper("freeShippingProduct", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        if (document.querySelector(".free-shipping") == null) return;
        this.slider = new Swiper(".free-shipping .swiper-container", {
          spaceBetween: 1,
          // centeredSlides: true,
          speed: 1400,
          loop: false,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          
          breakpoints,
        });
        setTimeout(() => {
          this.minHeight = document
            .querySelector(".free-shipping .swiper-container")
            .getBoundingClientRect().height;
        }, 1700);
      });
    },
  },
  computed:{
     freeShipping() {
       if(this.$store.getters["front/getHomeData"]!=null){
        console.log(this.$store.getters["front/getHomeData"],'freeeee');

        return this.$store.getters["front/getHomeData"].free_shipping_products;
      }else{
        return null
      }
    },
  }
};
</script>
<style>

</style>
<style scoped>

.freeShipping-icon{
    animation:truck 5s linear infinite;
    z-index:2;
    width:90px;
    height:90px;
}
@keyframes truck {
  from {
    transform: translateX(-200%);
  }
  to {
    transform: translateX(200%);
  }
}
.free-shipping{
   border-radius:15px;
}
.productContainer{
    width:75%;
   background-color:#c1efba;
   border-radius:15px;
}
.icon{
  z-index:2;
}
.title{
    width:25%;
}
.title a , .title h3{
    z-index:3;
    font-weight:bold;
    color:#039b47;
}

@media (max-width:1500px){
  .icon{
     z-index:2;
     overflow:hidden;
    width:100%;

  }
}
@media (max-width:1000px){
  .free-shipping{
   background-color:#c1efba;
  }
    .productContainer{
      width:100%
  }
  .freeShipping-icon{
      width:70px;
      height:70px;
    }  
  
  .free-shipping{
      flex-direction: column !important;
      padding:10px 20px;
  } 
  
  .title{
      width:100%;
      flex-direction: row !important;
     justify-content: space-between !important;
     padding:0 0 10px;
  }
  .title h3{
      background-color:#c1efba;
      width:20%;
  }
    .title .icon{
      width:70%;
    } 
  .free-shipping:before{
     width:100%;
  }  
   .freeShipping-icon{
    animation:truck 6s linear infinite;
  }
  @keyframes truck {
  from {
    transform: translateX(-600%);
  }
  to {
    transform: translateX(200%);
  }
  }
}
@media (max-width:800px){
  .freeShipping-icon{
    width:50px;
    height:50px;
  } 
  .title h3{
    width:20%;
  }
  .title .icon{
    width:70%;
  }
}

</style>
